import DeleteButton from './DeleteButton.view';
export default DeleteButton;
